// 客户是否分配
export const isAllotTypeList = [
  {
    dictCode: '0',
    dictLabel: '未分配'
  },
  {
    dictCode: '1',
    dictLabel: '已分配'
  }
]

// 证件类型
export const certiTypeList = [
  {
    dictCode: '1',
    dictLabel: '身份证'
  },
  {
    dictCode: '2',
    dictLabel: '户口本'
  },
  {
    dictCode: '3',
    dictLabel: '出生证明'
  },
  {
    dictCode: '4',
    dictLabel: '护照'
  },
  {
    dictCode: '5',
    dictLabel: '港澳往来大陆通行证'
  },
  {
    dictCode: '6',
    dictLabel: '台湾往来大陆通行证'
  }
]

// 是否
export const yesOrNoTypeList = [
  {
    dictCode: '1',
    dictLabel: '是'
  },
  {
    dictCode: '0',
    dictLabel: '否'
  }
]

// 是否
export const booleanTypeList = [
  {
    dictCode: false,
    dictLabel: '否'
  },
  {
    dictCode: true,
    dictLabel: '是'
  }
]

// 是否上下架
export const statusTypeList = [
  {
    dictCode: '2',
    dictLabel: '已上架'
  },
  {
    dictCode: '1',
    dictLabel: '未上架'
  },
  {
    dictCode: '0',
    dictLabel: '已下架'
  }
]

// 平台类型
export const sourceTypeList = [
  {
    dictCode: '1',
    dictLabel: '保代'
  },
  {
    dictCode: '10',
    dictLabel: '国盛'
  },
  {
    dictCode: '20',
    dictLabel: '中融'
  },
  {
    dictCode: '1000',
    dictLabel: '中联'
  },
  {
    dictCode: '1001',
    dictLabel: '涌金'
  }
]

// 头条类别
export const headLineTypeList = [
  {
    dictCode: '11',
    dictLabel: '产品'
  },
  {
    dictCode: '12',
    dictLabel: '行业'
  },
  {
    dictCode: '13',
    dictLabel: '销售技巧'
  }
]

// 比赛类型

export const raceTypesList = [
  {
    value: '200公里',
    label: '200公里',
    children: [{
      value: '五把抓',
      label: '五把抓',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '11取1',
      label: '11取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      },
      {
        value: 1000,
        label: 1000
      }]
    },
    {
      value: '22取1',
      label: '22取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      },
      {
        value: 1000,
        label: 1000
      }]
    },
    {
      value: '33取1',
      label: '33取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '家家乐',
      label: '家家乐',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '手机',
      label: '手机',
      children: [{
        value: 200,
        label: 200
      }]
    },
    {
      value: '幸运奖',
      label: '幸运奖',
      children: [{
        value: 200,
        label: 200
      }]
    }]
  },
  {
    value: '300公里',
    label: '300公里',
    children: [{
      value: '五把抓',
      label: '五把抓',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '11取1',
      label: '11取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      },
      {
        value: 1000,
        label: 1000
      }]
    },
    {
      value: '22取1',
      label: '22取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      },
      {
        value: 1000,
        label: 1000
      }]
    },
    {
      value: '33取1',
      label: '33取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '家家乐',
      label: '家家乐',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '手机',
      label: '手机',
      children: [{
        value: 200,
        label: 200
      }]
    },
    {
      value: '幸运奖',
      label: '幸运奖',
      children: [{
        value: 200,
        label: 200
      }]
    }]
  },
  {
    value: '500公里',
    label: '500公里',
    children: [{
      value: '五把抓',
      label: '五把抓',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '11取1',
      label: '11取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      },
      {
        value: 1000,
        label: 1000
      }]
    },
    {
      value: '22取1',
      label: '22取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      },
      {
        value: 1000,
        label: 1000
      }]
    },
    {
      value: '33取1',
      label: '33取1',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '家家乐',
      label: '家家乐',
      children: [{
        value: 200,
        label: 200
      },
      {
        value: 300,
        label: 300
      },
      {
        value: 500,
        label: 500
      }]
    },
    {
      value: '车',
      label: '车',
      children: [{
        value: 200,
        label: 200
      }]
    },
    {
      value: '手机',
      label: '手机',
      children: [{
        value: 200,
        label: 200
      }]
    },
    {
      value: '幸运奖',
      label: '幸运奖',
      children: [{
        value: 200,
        label: 200
      }]
    }]
  }]

// 企业注册人员规模
export const staffSizeList = [
  {
    dictCode: 1,
    dictLabel: '199人以下'
  },
  {
    dictCode: 2,
    dictLabel: '200-499人'
  },
  {
    dictCode: 3,
    dictLabel: '500-1999人'
  },
  {
    dictCode: 4,
    dictLabel: '2000-3499人'
  },
  {
    dictCode: 5,
    dictLabel: '3500人以上'
  }
]

// 企业注册可用平台
export const availServiceList = [
  {
    dictCode: '1',
    dictLabel: '展业工具'
  },
  {
    dictCode: '2',
    dictLabel: '寿险核心系统'
  },
  {
    dictCode: '3',
    dictLabel: '财险核心系统'
  },
  {
    dictCode: '4',
    dictLabel: '鲸云保运营系统'
  }
]

// 保单状态
export const policyStatusList = [
  {
    dictCode: '0',
    dictLabel: '未生效'
  },
  {
    dictCode: '1',
    dictLabel: '已生效'
  }
]

// 投保告知书状态
export const informBookstateList = [
  {
    dictCode: 'A',
    dictLabel: '未签署'
  },
  // {
  //   dictCode: 'B',
  //   dictLabel: '已签署'
  // },
  {
    dictCode: 'C',
    dictLabel: '已完成'
  }
]

// 性别
export const sexTypeList = [
  {
    dictCode: 'M',
    dictLabel: '男'
  },
  {
    dictCode: 'F',
    dictLabel: '女'
  }
]

// 性别
export const sexTypeList2 = [
  {
    dictCode: 1,
    dictLabel: '男'
  },
  {
    dictCode: 0,
    dictLabel: '女'
  }
]

// 用户资源类型
export const userResourceTypeList = [
  {
    dictCode: 1,
    dictLabel: '展业Icon'
  }
]

// 网销产品显示终端
export const showDeviceTypeList = [
  {
    dictCode: 0,
    dictLabel: '全部终端'
  },
  {
    dictCode: 1,
    dictLabel: 'APP'
  },
  {
    dictCode: 2,
    dictLabel: '小程序/公众号/H5页面'
  },
  {
    dictCode: 3,
    dictLabel: '其它'
  }
]

// 网销产品是否
export const onlineProductYesOrNoTypeList = [
  {
    dictCode: 0,
    dictLabel: '是'
  },
  {
    dictCode: 1,
    dictLabel: '否'
  }
]

// 启用状态
export const startStatusList = [
  {
    dictCode: 0,
    dictLabel: '已停用'
  },
  {
    dictCode: 1,
    dictLabel: '已启用'
  }
]

// 考试发布
export const onlineExamTypeList = [
  {
    dictCode: 1,
    dictLabel: '是'
  },
  {
    dictCode: 0,
    dictLabel: '否'
  }
]

// 网销产品 产品状态
export const onlineProductStatusTypeList = [
  {
    dictCode: 0,
    dictLabel: '上架'
  },
  {
    dictCode: 1,
    dictLabel: '下架'
  }
]

// 网销产品显示位置
export const showPositionTypeList = [
  {
    dictCode: 0,
    dictLabel: '产品列表'
  }
]

// 用户资源类型-跳转类型
export const jumpTypeList = [
  {
    dictCode: '1',
    dictLabel: 'H5'
  },
  {
    dictCode: '2',
    dictLabel: '原生'
  }
]

// 机构入司配置-合同签署方式
export const signTypeList = [
  {
    dictCode: 1,
    dictLabel: '法大大'// ca
  },
  {
    dictCode: 2,
    dictLabel: 'e签宝'// 非ca
  }
]

// 机构入司配置-影响范围
export const signScopeList = [
  {
    dictCode: 1,
    dictLabel: '全公司'
  },
  {
    dictCode: 2,
    dictLabel: '分公司'
  }
]

// 用户资源管理-标签
export const tagTypeList = [
  {
    dictCode: 1,
    dictLabel: '展业辅助'
  },
  {
    dictCode: 2,
    dictLabel: '展业工具'
  }
]

// 头条素材状态
export const headlineMaterialTypeList = [
  {
    dictCode: '0',
    dictLabel: '未使用'
  },
  {
    dictCode: '1',
    dictLabel: '已使用'
  },
  {
    dictCode: '2',
    dictLabel: '已弃用'
  }
]

// 产品管理 产品状态
export const productStatusTypeList = [
  {
    dictCode: 0,
    dictLabel: '下架'
  },
  {
    dictCode: 1,
    dictLabel: '上架'
  }
]

// 发版管理-应用平台
export const applicationTypeList = [
  {
    dictCode: 1,
    dictLabel: 'Android'
  },
  {
    dictCode: 2,
    dictLabel: 'IOS'
  }
]

// 订单管理-公司
export const companyTypeList = [
  {
    dictCode: 'niubao',
    dictLabel: '小雨伞'
  },
  {
    dictCode: 'huize',
    dictLabel: '齐心'
  },
  {
    dictCode: 'aixinlife',
    dictLabel: '爱心人寿'
  },
  {
    dictCode: 'huagui_life',
    dictLabel: '华贵人寿'
  },
  {
    dictCode: 'zhonghui',
    dictLabel: '众惠'
  },
  {
    dictCode: 'hengqin_life',
    dictLabel: '横琴人寿'
  }
]

// 订单管理-缴费频率
export const payTypeList = [
  {
    dictCode: 'M',
    dictLabel: '月缴、月付'
  },
  {
    dictCode: 'Y',
    dictLabel: '年缴'
  },
  {
    dictCode: '0',
    dictLabel: '趸交'
  }
]

// 订单管理-缴费年限
export const payYearsTypeList = [
  {
    dictCode: '',
    dictLabel: '短险'
  },
  {
    dictCode: '1',
    dictLabel: '缴N年'
  },
  {
    dictCode: '2',
    dictLabel: '缴到N岁'
  }
]

// 订单管理-受益人类型
export const beneTypeList = [
  {
    dictCode: '1',
    dictLabel: '被保人本人'
  },
  {
    dictCode: '2',
    dictLabel: '法定受益人'
  },
  {
    dictCode: '3',
    dictLabel: '指定受益人'
  }
]

// 订单管理-受益人顺位
export const gradeTypeList = [
  {
    dictCode: '1',
    dictLabel: '第一顺位'
  },
  {
    dictCode: '2',
    dictLabel: '第二顺位'
  },
  {
    dictCode: '3',
    dictLabel: '第三顺位'
  },
  {
    dictCode: '0',
    dictLabel: '不区分顺位'
  }
]

// 订单管理-保障期限类型
export const insuredPeriodTypeList = [
  {
    dictCode: '1',
    dictLabel: ' M年'
  },
  {
    dictCode: '2',
    dictLabel: '保至M岁'
  },
  {
    dictCode: '3',
    dictLabel: '保M天'
  },
  {
    dictCode: '4',
    dictLabel: '保终身'
  },
  {
    dictCode: '5',
    dictLabel: '保M月'
  },
  {
    dictCode: '6',
    dictLabel: '保M周'
  }
]

// 与被保人的关系
export const relationWithInsurantTypeList = [
  {
    dictCode: '1',
    dictLabel: ' 本人'
  },
  {
    dictCode: '2',
    dictLabel: '丈夫'
  },
  {
    dictCode: '3',
    dictLabel: '妻子'
  },
  {
    dictCode: '4',
    dictLabel: '父亲'
  },
  {
    dictCode: '5',
    dictLabel: '母亲'
  },
  {
    dictCode: '6',
    dictLabel: '儿子'
  },
  {
    dictCode: '7',
    dictLabel: '女儿'
  },
  {
    dictCode: '8',
    dictLabel: '祖父'
  },
  {
    dictCode: '9',
    dictLabel: '祖母'
  },
  {
    dictCode: '10',
    dictLabel: '外祖父'
  },
  {
    dictCode: '11',
    dictLabel: '外祖母'
  },
  {
    dictCode: '12',
    dictLabel: '孙子'
  },
  {
    dictCode: '13',
    dictLabel: '孙女'
  },
  {
    dictCode: '14',
    dictLabel: '外孙'
  },
  {
    dictCode: '15',
    dictLabel: '外孙女'
  },
  {
    dictCode: '16',
    dictLabel: '其他'
  }
]

// 保单状态
export const policyStatusTypeList = [
  {
    dictCode: '1',
    dictLabel: ' 待提交'
  },
  {
    dictCode: '101',
    dictLabel: '投保提交'
  },
  {
    dictCode: '110',
    dictLabel: '已拆分'
  },
  {
    dictCode: '201',
    dictLabel: '核保中'
  },
  {
    dictCode: '202',
    dictLabel: '投保失败'
  },
  {
    dictCode: '203',
    dictLabel: '投保成功'
  },
  {
    dictCode: '211',
    dictLabel: '自核通过'
  },
  {
    dictCode: '212',
    dictLabel: '人工核保中'
  },
  {
    dictCode: '213',
    dictLabel: '核保通过'
  },
  {
    dictCode: '214',
    dictLabel: '延期'
  },
  {
    dictCode: '215',
    dictLabel: '拒保'
  },
  {
    dictCode: '216',
    dictLabel: '其他'
  },
  {
    dictCode: '217',
    dictLabel: '已撤单'
  },
  {
    dictCode: '301',
    dictLabel: '收费成功'
  },
  {
    dictCode: '302',
    dictLabel: '收费失败'
  },
  {
    dictCode: '303',
    dictLabel: '转账收费中'
  },
  {
    dictCode: '304',
    dictLabel: '退费成功'
  },
  {
    dictCode: '305',
    dictLabel: '退费失败'
  },
  {
    dictCode: '306',
    dictLabel: '退费中'
  },
  {
    dictCode: '307',
    dictLabel: '线下批扣中'
  },
  {
    dictCode: '401',
    dictLabel: '已承保'
  },
  {
    dictCode: '402',
    dictLabel: '已回执'
  },
  {
    dictCode: '403',
    dictLabel: '已回访'
  },
  {
    dictCode: '0',
    dictLabel: '删除'
  },
  {
    dictCode: '501',
    dictLabel: '退保成功'
  }
]

// 订单管理-商品类型
export const goodsTypeList = [
  {
    dictCode: '1000001',
    dictLabel: ' 全部'
  },
  {
    dictCode: '4138',
    dictLabel: '医疗'
  },
  {
    dictCode: '4139',
    dictLabel: '意外'
  },
  {
    dictCode: '4140',
    dictLabel: '重疾'
  },
  {
    dictCode: '4141',
    dictLabel: '寿险'
  },
  {
    dictCode: '4231',
    dictLabel: '年金'
  }
]

// 工号管理-区域类型
export const areaTypeList = [
  {
    dictCode: '1',
    dictLabel: '保代'
  },
  {
    dictCode: '0',
    dictLabel: '国盛'
  },
  {
    dictCode: '20',
    dictLabel: '中融'
  },
  {
    dictCode: '1000',
    dictLabel: '中联'
  },
  {
    dictCode: '1001',
    dictLabel: '涌金'
  }
]

// 在线入司-审核状态
export const approvalStatusTypeList = [
  {
    dictCode: '0',
    dictLabel: '待审核'
  },
  {
    dictCode: '1',
    dictLabel: '通过'
  },
  {
    dictCode: '2',
    dictLabel: '拒绝'
  }
]

// 作业管理-关联活动
export const activitiesTypeList = [
  // {
  //   dictCode: 0,
  //   dictLabel: '无'
  // },
  {
    dictCode: 0,
    dictLabel: '线上课'
  },
  {
    dictCode: 1,
    dictLabel: '线下培训'
  }
]

// 作业管理-状态
export const homeworkStatusTypeList = [
  {
    dictCode: 0,
    dictLabel: '未发布'
  },
  {
    dictCode: 1,
    dictLabel: '已发布'
  }
]

// 线下培训-状态
export const trainStateTypeList = [
  {
    dictCode: 0,
    dictLabel: '编辑中'
  },
  {
    dictCode: 1,
    dictLabel: '未开始'
  },
  {
    dictCode: 2,
    dictLabel: '进行中'
  },
  {
    dictCode: 3,
    dictLabel: '已结束'
  }
]

// 考试状态
export const examStatusList = [
  {
    dictCode: 0,
    dictLabel: '未开始'
  },
  {
    dictCode: 1,
    dictLabel: '考试中'
  },
  {
    dictCode: 2,
    dictLabel: '已结束'
  }
]

// 试卷 - 出题方式
export const paperModelTypeList = [
  {
    dictCode: 0,
    dictLabel: '选题组卷'
  },
  {
    dictCode: 1,
    dictLabel: '一人一卷'
  }
]

// 试卷 - 出题方式
export const questionTypeList = [
  {
    dictCode: 0,
    dictLabel: '单选题'
  },
  {
    dictCode: 1,
    dictLabel: '多选题'
  },
  {
    dictCode: 2,
    dictLabel: '判断题'
  },
  {
    dictCode: 3,
    dictLabel: '简答题'
  }
]

// 试卷 - 出题方式
export const difficultTypeList = [
  {
    dictCode: 0,
    dictLabel: '易'
  },
  {
    dictCode: 1,
    dictLabel: '难'
  }
]

// 培训 - 海报类型
export const posterTypeList = [
  {
    dictCode: 0,
    dictLabel: '上传图片'
  },
  {
    dictCode: 1,
    dictLabel: '模板1'
  },
  {
    dictCode: 2,
    dictLabel: '模板2'
  },
  {
    dictCode: 3,
    dictLabel: '模板3'
  },
  {
    dictCode: 4,
    dictLabel: '模板4'
  }
]

// 高端医疗-证件类型
export const highMedicalCerType = [
  {
    dictCode: 0,
    dictLabel: '身份证'
  },
  {
    dictCode: 1,
    dictLabel: '护照'
  },
  {
    dictCode: 2,
    dictLabel: '户口本'
  },
  {
    dictCode: 3,
    dictLabel: '出生证'
  },
  {
    dictCode: 4,
    dictLabel: '港澳台通行证'
  },
  {
    dictCode: 5,
    dictLabel: '其他'
  }
]

// 高端医疗-性别
export const highMedicalSexType = [
  {
    dictCode: true,
    dictLabel: '女'
  },
  {
    dictCode: false,
    dictLabel: '男'
  }
]

// 高端医疗-支付状态
export const highMedicalpayType = [
  // 0待支付  1已上传截图  2已支付待承保  3承保成功 4承保前退款 5已退保
  {
    dictCode: 0,
    dictLabel: '待支付'
  },
  {
    dictCode: 1,
    dictLabel: '已上传截图'
  },
  {
    dictCode: 2,
    dictLabel: '已支付待承保'
  },
  {
    dictCode: 3,
    dictLabel: '承保成功'
  },
  {
    dictCode: 4,
    dictLabel: '已退款'
  },
  {
    dictCode: 5,
    dictLabel: '已退保'
  }
]

// 工作汇报-审批状态
export const myReportStateList = [
  {
    dictCode: 0,
    dictLabel: '未提审'
  },
  {
    dictCode: 1,
    dictLabel: '未审批'
  },
  // {
  //   dictCode: 2,
  //   dictLabel: '审批中'
  // },
  {
    dictCode: 3,
    dictLabel: '审批通过'
  },
  {
    dictCode: 4,
    dictLabel: '审批拒绝'
  }
]

// 工作汇报-汇报类型
export const myApprovalTypeList = [
  {
    dictCode: 0,
    dictLabel: '班次项目汇报'
  },
  {
    dictCode: 1,
    dictLabel: '月度机构汇报'
  }
]
// 客户告知书-告知书状态
export const notificationStatus = [
  // 0:待支付、1:已上传截图、2:已支付、3：已退款'
  {
    dictCode: 'A',
    dictLabel: '未签署'
  },
  {
    dictCode: 'B',
    dictLabel: '已签署'
  },
  {
    dictCode: 'C',
    dictLabel: '已确认'
  }
]

// 高端医疗-订单类型
export const highMedicalType = [
  {
    dictCode: '0',
    dictLabel: '鲸云保APP'
  },
  {
    dictCode: '1',
    dictLabel: '航旅纵横'
  },
  {
    dictCode: '2',
    dictLabel: '易保险'
  },
  {
    dictCode: '3',
    dictLabel: '壹心宝-审核'
  },
  {
    dictCode: '4',
    dictLabel: '社区推广'
  }
]

// 机构管理-CA认证type
export const orginCAStatusList = [
  {
    dictCode: 'A',
    dictLabel: 'CA认证'
  },
  {
    dictCode: 'B',
    dictLabel: '非CA认证'
  }
]

// 机构管理-负责人身份
export const leaderIdentityList = [
  {
    dictCode: 'A',
    dictLabel: '代理人'
  },
  {
    dictCode: 'B',
    dictLabel: '法人'
  }
]

// 交付状态
export const areaCodeList = [
  {
    dictCode: 'WAITING',
    dictLabel: '未交付'
  },
  {
    dictCode: 'PASSED',
    dictLabel: '交付中'
  },
  {
    dictCode: 'SUCCESS',
    dictLabel: '已交付'
  }
]

// 作业形式
export const homeworkTypeList = [
  {
    dictCode: 0,
    dictLabel: '纯文本'
  },
  {
    dictCode: 1,
    dictLabel: '纯图片或视频'
  },
  {
    dictCode: 2,
    dictLabel: '文本+图片或视频'
  }
]

export const homeworkStatusList = [
  {
    dictCode: 0,
    dictLabel: '未提交'
  },
  {
    dictCode: 1,
    dictLabel: '未批改'
  },
  {
    dictCode: 2,
    dictLabel: '已批改'
  }
]

export const orderStatusList = [
  { dictCode: 1, dictLabel: '待提交' },
  { dictCode: 101, dictLabel: '投保提交' },
  { dictCode: 201, dictLabel: '核保中' },
  { dictCode: 202, dictLabel: '投保失败' },
  { dictCode: 211, dictLabel: '自核通过' },
  { dictCode: 212, dictLabel: '人工核保中' },
  { dictCode: 213, dictLabel: '核保通过' },
  { dictCode: 214, dictLabel: '延期' },
  { dictCode: 215, dictLabel: '拒保' },
  { dictCode: 217, dictLabel: '已撤单' },
  { dictCode: 219, dictLabel: '核保失败' },
  { dictCode: 301, dictLabel: '收费成功' },
  { dictCode: 302, dictLabel: '收费失败' },
  { dictCode: 303, dictLabel: '转账收费中' },
  { dictCode: 401, dictLabel: '已承保' },
  { dictCode: 402, dictLabel: '已回执' },
  { dictCode: 403, dictLabel: '已回访' },
  { dictCode: 501, dictLabel: '犹豫期退保' },
  { dictCode: 601, dictLabel: '已退保' },
  { dictCode: 0, dictLabel: '失效' }
]

export const hasNoList = [
  {
    dictCode: 0,
    dictLabel: '无'
  },
  {
    dictCode: 1,
    dictLabel: '有'
  }
]

// 培训补卡申请
export const trainApprovalStateList = [
  {
    dictCode: 0,
    dictLabel: '未提交'
  },
  {
    dictCode: 1,
    dictLabel: '待审批'
  },
  {
    dictCode: 2,
    dictLabel: '审批通过'
  },
  {
    dictCode: 3,
    dictLabel: '审批驳回'
  }
]

export const signStateList = [
  {
    dictCode: 0,
    dictLabel: '未签到'
  },
  {
    dictCode: 1,
    dictLabel: '已签到'
  },
  {
    dictCode: 2,
    dictLabel: '提交补卡'
  },
  {
    dictCode: 3,
    dictLabel: '已补卡'
  }
]
